import { useEffect, useState } from "react";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { AdminHead } from "./AdminLayout";
import { Field, ImageUpload } from "./ImageUpload";
import { api, useAction, useSettings } from "../../lib/api";

const FIELDS = [
  ["whatsapp", "Nomor WhatsApp (format 62xxx)", "6281234567890"],
  ["email", "Alamat Email", "info@domain.com"],
  ["instagram", "Link Instagram", "https://instagram.com/..."],
  ["facebook", "Link Facebook", "https://facebook.com/..."],
  ["tiktok", "Link TikTok", "https://tiktok.com/@..."],
  ["youtube", "Link YouTube", "https://youtube.com/..."],
];

export default function AdminSettings() {
  const { data } = useSettings();
  const [f, setF] = useState(null);
  const act = useAction(["settings"]);
  useEffect(() => {
    if (data) setF(data);
  }, [data]);
  if (!f) return <p>Memuat...</p>;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <form onSubmit={(e) => { e.preventDefault(); act(() => api.put("/settings", f), "Pengaturan disimpan"); }} data-testid="settings-form">
      <AdminHead title="Pengaturan Situs" desc="Perubahan langsung tampil di seluruh halaman website.">
        <button type="submit" className="btn-forest" data-testid="settings-save-button">Simpan Pengaturan</button>
      </AdminHead>
      <div className="mb-6 grid gap-5 rounded-3xl border bg-white p-6 md:grid-cols-2 md:p-8">
        <div>
          <Field label="Ikon Logo (tampil di kiri tulisan Sembada Satwa, PNG transparan disarankan)">
            <ImageUpload value={f.logo_url} onChange={(u) => setF({ ...f, logo_url: u })} testid="settings-logo-upload" aspect="aspect-[3/1]" fit="object-contain p-4" />
          </Field>
          {f.logo_url && <button type="button" onClick={() => setF({ ...f, logo_url: "" })} className="mt-2 text-xs text-red-600 hover:underline" data-testid="settings-logo-reset">Kembalikan logo sapi bawaan</button>}
        </div>
        <div>
          <Field label="Gambar Hero Beranda (lebar, min. 1600px)">
            <ImageUpload value={f.hero_image_url} onChange={(u) => setF({ ...f, hero_image_url: u })} testid="settings-hero-upload" aspect="aspect-[3/1]" />
          </Field>
          {f.hero_image_url && <button type="button" onClick={() => setF({ ...f, hero_image_url: "" })} className="mt-2 text-xs text-red-600 hover:underline" data-testid="settings-hero-reset">Kembalikan gambar bawaan</button>}
        </div>
      </div>
      <div className="grid gap-5 rounded-3xl border bg-white p-6 md:grid-cols-2 md:p-8">
        {FIELDS.map(([k, label, ph]) => (
          <Field key={k} label={label}><Input value={f[k]} placeholder={ph} onChange={set(k)} data-testid={`settings-${k}-input`} /></Field>
        ))}
        <div className="md:col-span-2"><Field label="Alamat"><Textarea rows={2} value={f.address} onChange={set("address")} data-testid="settings-address-input" /></Field></div>
        <div className="md:col-span-2">
          <Field label="URL Embed Google Maps">
            <Input value={f.maps_embed_url} onChange={set("maps_embed_url")} data-testid="settings-maps-input" />
          </Field>
          <p className="mt-2 text-xs text-[var(--ink)]/50">Buka Google Maps → Bagikan → Sematkan peta → salin URL di dalam atribut src="...".</p>
        </div>
      </div>
    </form>
  );
}
